// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buttonWrapper {\n  display: inline-block;\n}\n\n.button {\n  background: #fbfbfb;\n  color: #888;\n  font-size: 18px;\n  border: 0;\n  padding-top: 5px;\n  vertical-align: bottom;\n  height: 34px;\n  width: 36px;\n}\n\n.button svg {\n  fill: #888;\n}\n\n.button:hover,\n.button:focus {\n  background: #f3f3f3;\n  outline: 0; /* reset for :focus */\n}\n\n.active {\n  background: #efefef;\n  color: #444;\n}\n\n.active svg {\n  fill: #444;\n}\n", ""]);
// Exports
module.exports = exports;
